import { createContext, useState, useContext } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [showLoading, setShowLoading] = useState(true);

  const triggerLoading = (value) => {
    setShowLoading(value);
  };

  return (
    <LoadingContext.Provider value={{ showLoading, triggerLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
